import { memo } from "react";
import { MerchantGroupName } from "consts/merchants";
import { ECommerceOutlet } from "./ECommerce";
import Merchant from "./Merchant";
import useMerchants from "./useMerchants";

const merchants = new Map()
    .set(MerchantGroupName.ECommerce, ECommerceOutlet);

const Merchants = () => {
    const { selectMerchantGroupName } = useMerchants();

    const MerchantComponent = merchants.get(selectMerchantGroupName()) ?? Merchant;

    return (
        <MerchantComponent />
    );
};

export default memo(Merchants);
